export default __webpack_public_path__ + "static/media/wisconsin.bbc9ba15.jpg";